var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link_01"},[_c('div',{staticClass:"equipos-1 avenirnextltpro-medium-big-stone-10px",on:{"click":_vm.clickBreadCrumbs}},[_vm._v(" Equipos – Seleccionar equipo ")])])}
var staticRenderFns = []

export { render, staticRenderFns }